import { defineMessages } from 'react-intl';

export const i18n: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	suggestedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'search-page-relay.filters.product-filters.slack-channel.label',
		defaultMessage: 'Channel',
		description: 'Label for the Slack channel filter dropdown',
	},
	placeholder: {
		id: 'search-page-relay.filters.product-filters.slack-channel.placeholder',
		defaultMessage: 'Filter by channel',
		description: 'Placeholder text for the Slack channel filter search input',
	},
	selectedLabel: {
		id: 'search-page-relay.filters.product-filters.slack-channel.selected-label',
		defaultMessage: 'Selected',
		description: 'Group label for selected channels in the dropdown',
	},
	suggestedLabel: {
		id: 'search-page-relay.filters.product-filters.slack-channel.suggested-label',
		defaultMessage: 'Channels',
		description: 'Group label for suggested channels in the dropdown',
	},
});
